module.exports = __webpack_public_path__ + "static/clink-7a6101bd17b2b35ab43f7ebdbeaaa707.png";